import { h } from 'preact'
import { lazy } from 'preact/compat'
import URL_TOKEN from '../../shared/urlToken'

const SelfScheduler = lazy(() => import('../self-scheduler/self-scheduler'))
const AppointmentManager = lazy(() => import('../appointment-manager/appointment-manager'))

const WidgetRouter: preact.FunctionalComponent = () => {
    if (URL_TOKEN) {
        return <AppointmentManager />
    }
    return <SelfScheduler />
}

export default WidgetRouter
